import { ref } from 'vue';
import { deepCopy } from '@/tool/format';
import { FIELDS } from './ai-fields';
import { useAiDialogueStore } from '@/stores/aiDialogue';
export function useAiAnalyzeMethods() {
  const { sendMessage, reflectAIChatHistory } = useAiDialogueStore();
  let isUpdate = ref(false);
  let additional = ref({});

  // 判断提交的表单是否大于 2
  const MergeFormPrompt = (data, additional) => {
    console.log('判断提交的表单是否大于', data);
    let forms = Object.keys(data);
    let snedDatas = {
      query: '',
      showView: {
        hideFeilds: {
          update: isUpdate.value,
          ...additional,
        },
      },
    };
    // 提示词 && 数据
    let result = forms.forEach(key => {
      snedDatas.query += `
      这是我提交的${data[key]['showView']?.['title'] || ''
        }，请对比分析该批次下目标系统的养殖记录数据，给出养殖优化建议或经验， 内容层次清晰、结构化呈现。 :${JSON.stringify(
          data[key]['currentData']
        )}
      \n
      `;
    });

    // 判断是否提交多个表单
    if (forms?.length > 1) {
      snedDatas.showView['titls'] = forms.map(
        key => data[key]['showView']?.['title'] || ''
      );
    } else {
      snedDatas['showView'] = {
        ...snedDatas.showView,
        ...data[forms[0]]['showView'],
      };
    }

    console.log('查看合并后的对象', snedDatas);
    return snedDatas;
  };

  // 调用ai会话
  const sendAianalysis = async (forms, additional) => {
    let data = MergeFormPrompt(forms, additional);
    let result = reflectAIChatHistory(data.showView, '', data.query);

    // for (const key in data) {
    try {
      // 创建Promise处理异步操作
      await new Promise((resolve, reject) => {
        // 构造查询内容
        // 调用sendMessage并处理回调
        sendMessage(
          result,
          (error, result) => {
            // 假设第三个参数是回调函数
            if (error) {
              reject(error); // 处理错误
            } else {
              console.log('AI回答完毕:', result);
              resolve(result); // 成功时解析Promise
            }
          },
          'form'
        );
      });
      // 可选：在循环结束后处理每个结果（如果需要）
      // 例如：保存结果或触发其他操作
    } catch (error) {
      console.error(`处理${key}时出错:`, error);
      // 可选：继续处理其他项或终止
    }
    // }
  };

  // 单独处理投喂
  const enhanceFieldFeeding = (obj, fieldsToKeep = [], extraData = []) => {
    const feedingRequest = obj.feedingRequest;
    const details = feedingRequest.details || [];

    // 统计weight部分
    const totals = {};
    details.forEach(item => {
      const name = item.title || item.baitName;
      const unit = item.unit;
      if (!totals[name]) {
        totals[name] = {
          total: 0,
          unit: unit,
        };
      }
      const weight = parseFloat(item.weight) || 0;
      totals[name].total += weight;
    });

    // 构造showView的基础部分
    const showView = {};
    for (const name in totals) {
      if (totals.hasOwnProperty(name)) {
        const total = totals[name].total.toFixed(2);
        const unit = totals[name].unit;
        showView[name] = `${total} ${unit}`;
      }
    }

    // 处理extraData添加到showView
    extraData.forEach(entry => {
      const key = entry.key;
      const value = obj[key];
      if (value !== undefined) {
        if (key === 'batchCode') {
          showView['批次编号'] = value;
        } else if (key === 'systemCode') {
          showView['系统编号'] = value;
        } else {
          showView[key] = value;
        }
      }
    });
    console.log('showView', showView);

    // 处理currentData的details数组
    const filteredDetails = details.map(item => {
      const filteredItem = {};
      fieldsToKeep.forEach(field => {
        if (item.hasOwnProperty(field)) {
          filteredItem[field] = item[field];
        }
      });
      return filteredItem;
    });

    // 构造currentData并添加extraData
    const currentData = {
      details: filteredDetails,
    };
    extraData.forEach(entry => {
      const key = entry.key;
      const value = obj[key];
      if (value !== undefined) {
        currentData[key] = value;
      }
    });

    return {
      feedingRequest: {
        showView,
        currentData,
      },
    };
  };

  // 单独处理损耗
  const enhanceFieldLoss = (data, extraData, selectedFields) => {
    const result = {
      showView: {
        title: '损耗记录', // 可根据需求动态生成标题
      },
      currentData: {},
    };

    // 统计损耗重量和数量
    let totalWeight = 0;
    let totalCount = 0;
    data.lossRequest.details.forEach(detail => {
      totalWeight += Number(detail.lossWeight);
      totalCount += Number(detail.lossCount);
    });
    result.showView['损耗重量'] = totalWeight;
    result.showView['损耗数量'] = totalCount;

    // 添加额外数据到 showView 和 currentData
    extraData.forEach(item => {
      const { key, text } = item;
      if (data.hasOwnProperty(key)) {
        result.showView[text] = data[key];
        result.currentData[text] = data[key]; // 同步到 currentData
      }
    });

    // 处理 details 数组并过滤字段
    const filteredDetails = data.lossRequest.details.map(detail => {
      const filteredDetail = {};
      selectedFields.forEach(field => {
        if (detail.hasOwnProperty(field)) {
          filteredDetail[field] = detail[field];
        }
      });
      return filteredDetail;
    });
    result.currentData.details = filteredDetails; // 将过滤后的 details 放入 currentData

    return {
      lossRequest: result,
    };
  };

  // 单独处理损耗
  const enhanceFieldAquaMedication = (data, extraData, selectedFields) => {
    const result = {
      showView: {
        title: '每日用药记录', // 可根据需求动态生成标题
      },
      currentData: {},
    };

    data.aquaMedication.medicationDetails.forEach((item, index) => {
      result.showView[`药品名称${index + 1}`] = item.medicine;
      result.showView[`${item.medicine}剂量`] = item.dosage;
      result.showView[`${item.medicine}给药方式`] = item.method;
      result.showView[`${item.medicine}用途`] = item.purpose;
    });

    // 处理 details 数组并过滤字段
    const filteredDetails = data.aquaMedication.medicationDetails.map(
      detail => {
        const filteredDetail = {};

        selectedFields.forEach(field => {
          console.log(
            'detail',
            detail,
            'field',
            field,
            'detail.hasOwnProperty(field)',
            detail.hasOwnProperty(field)
          );
          if (detail.hasOwnProperty(field)) {
            filteredDetail[field] = detail[field];
          }
        });
        return filteredDetail;
      }
    );
    console.log('filteredDetails', filteredDetails);

    result.currentData.medicationDetails = filteredDetails; // 将过滤后的 details 放入 currentData

    return {
      aquaMedication: result,
    };
  };

  // 格式化展示数据
  const enhanceFields = datas => {
    console.log('格式化展示数据', datas);
    isUpdate.value = datas.update;
    // 深拷贝原始fields对象，避免修改原对象
    const newFields = deepCopy(FIELDS);
    // 遍历newFields的每个一级属性
    Object.keys(newFields).forEach(fieldKey => {
      const fieldConfig = newFields[fieldKey];
      const dataSection = datas[fieldKey]; // datas中对应的一级属性
      // 初始化处理后的数据容器
      const processed = {
        showView: {},
        currentData: {},
        filteredData: fieldConfig.filteredData || [],
        extraData: fieldConfig.extraData || [],
      };
      // 单独处理投喂
      if (
        fieldKey == '_feedingRequest' &&
        datas.hasOwnProperty('feedingRequest')
      ) {
        let holdFeilds = newFields['_feedingRequest']['holdFeilds'];
        let extraData = newFields['_feedingRequest']['extraData'];
        let result = enhanceFieldFeeding(datas, holdFeilds, extraData);
        result['feedingRequest']['showView']['title'] = '投喂记录';
        newFields['feedingRequest'] = result.feedingRequest;

        // 单独处理损耗
      } else if (
        fieldKey == '_lossRequest' &&
        datas.hasOwnProperty('lossRequest')
      ) {
        let holdFeilds = newFields['_lossRequest']['holdFeilds'];
        let extraData = newFields['_lossRequest']['extraData'];
        let result = enhanceFieldLoss(datas, extraData, holdFeilds);
        result['lossRequest']['showView']['title'] = '损耗记录';
        result['lossRequest']['currentData']['title'] = '损耗记录';
        newFields['lossRequest'] = result.lossRequest;
      } else if (
        fieldKey == '_aquaMedication' &&
        datas.hasOwnProperty('aquaMedication')
      ) {
        let holdFeilds = newFields['_aquaMedication']['holdFeilds'];
        let extraData = newFields['_aquaMedication']['extraData'];
        let result = enhanceFieldAquaMedication(datas, extraData, holdFeilds);
        result['aquaMedication']['showView']['title'] = '每日用药记录';
        result['aquaMedication']['currentData']['title'] = '每日用药记录';
        newFields['aquaMedication'] = result.aquaMedication;
        console.log(
          'newFields aquaMedicatio',
          newFields['aquaMedication'],
          result
        );
      } else if (dataSection) {
        // 处理showView映射
        Object.entries(fieldConfig.showView).forEach(
          ([displayName, dataKey]) => {
            // 过滤逻辑：值存在、非空字符串、不在过滤列表中
            if (
              (dataSection[dataKey] !== undefined &&
                dataSection[dataKey] !== '' &&
                !processed.filteredData.includes(dataKey)) ||
              displayName == 'title'
            ) {
              processed.showView[displayName] = dataSection[dataKey];
              processed.currentData[dataKey] = dataSection[dataKey];
              // 给title赋值
              if (displayName == 'title') {
                processed.showView['title'] = dataKey;
                processed.currentData['title'] = dataKey;
                delete processed.currentData[dataKey];
              }
            }
          }
        );

        // 处理额外数据
        processed.extraData.forEach(({ key, text }) => {
          if (datas[key] !== undefined) {
            // 检查一级属性
            processed.showView[text] = datas[key];
            processed.currentData[key] = datas[key];
          }
        });
      }

      // 更新配置对象
      fieldConfig.showView = processed.showView;
      fieldConfig.currentData = processed.currentData;
      fieldConfig.currentData['reportId'] = datas['reportId'];

      // 额外添加的字段，需要在给当前上报表单做操作
      additional.value = {
        reportId: datas['reportId'],
        systemCode: datas['systemCode'],
        batchCode: datas['batchCode'],
        systemId: datas['systemId'],
        batchId: datas['batchId'],
        prportype: datas['prportype'],
      };
    });

    // 过滤逻辑：只保留datas中存在的顶层属性
    Object.keys(newFields).forEach(fieldKey => {
      if (!datas.hasOwnProperty(fieldKey)) {
        delete newFields[fieldKey];
      }
    });

    sendAianalysis(newFields, additional.value);
    return newFields;
  };

  // 暴露的方法
  return {
    enhanceFields,
  };
}
